import { Chip as Tag } from '@material-ui/core';

import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

import styles from './StateTag.module.css';

const SUCCESS_STATES = new Set([
  'active',
  'live',
  'completed',
  'allocated',
  'ok',
]);
const WARNING_STATES = new Set([
  'draft',
  'pending',
  'running',
  'unallocated',
  'in_review',
]);
const DANGER_STATES = new Set(['aborted', 'failed', 'error', 'rejected']);

const normalizeState = (state: string) =>
  state.replace(/^STATE_/, '').toLowerCase();

const getColorClass = (state: string): string | undefined => {
  const normalized = normalizeState(state);
  if (SUCCESS_STATES.has(normalized)) return styles.success;
  if (WARNING_STATES.has(normalized)) return styles.warning;
  if (DANGER_STATES.has(normalized)) return styles.danger;
  return undefined;
};

interface StateTagProps {
  state: string;
}

export const StateTag = ({ state }: StateTagProps) => {
  const label = startCase(toLower(state));
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'var(--bui-space-2)',
      }}
      aria-label={label}
    >
      <Tag
        id={state}
        label={label}
        size="small"
        className={getColorClass(state)}
      />
    </div>
  );
};
